// extracted by mini-css-extract-plugin
export default {"adminPanelMenu":"AdministrationMenu_adminPanelMenu__66zLJ"};